import React from "react";

const NotFound = ({
    parent,
}: {
    parent:
        | "index"
        | "clubhouse"
        | "leaguemanagement"
        | "leagues"
        | "sitemanagement";
}): React.JSX.Element => {
    let errorContent: React.ReactNode;

    switch (parent) {
        case "clubhouse":
            errorContent = "Clubhouse Page Not Found";
            break;
        case "leaguemanagement":
            errorContent = "League Management Page Not Found";
            break;
        case "leagues":
            errorContent = "League Page Not Found";
            break;
        case "sitemanagement":
            errorContent = "Site Management Page Not Found";
            break;
        default:
            errorContent = "Page Not Found";
            break;
    }

    return <h2>{errorContent}</h2>;
};

export default NotFound;
